import React, { useState } from "react";
import { getCoachCreditOverview } from "../../student_dashboard/api";
import { useEffect } from "react";

const useCoachOverview = ({ coachId }) => {
  const [coachCreditOverview, setCoachCreditOverview] = React.useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchCoachCreditOverview = async ({ coachId }) => {
    if (!coachId) return;
    try {
      const creditOverview = await getCoachCreditOverview({ coachId });

      console.log("creditOverview", creditOverview);
      setCoachCreditOverview(creditOverview);
    } catch (error) {
      console.error("Error fetching coachCreditOverview:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCoachCreditOverview({ coachId: coachId });
  }, [coachId]);

  return { coachCreditOverview, isLoading, fetchCoachCreditOverview };
};

export default useCoachOverview;
